// extracted by mini-css-extract-plugin
module.exports = {"Slider_wrapper":"Slider_Slider_wrapper__2Q1do","Slider_slide":"Slider_Slider_slide__36Tu5","Slider_heading":"Slider_Slider_heading__FpWi9"};